import i18n from "@Shared/@i18n";
import { get } from "lodash";
export const rules = {
  required: {
    full: () => i18n.t("form-validations.required.full"),
    soft: () => i18n.t("form-validations.required.soft")
  },
  requiredSin: {
    full: () => i18n.t("form-validations.required.full"),
    soft: () => i18n.t("form-validations.required.soft")
  },
  email: {
    full: () => i18n.t("form-validations.validEmail.full"),
    soft: () => i18n.t("form-validations.validEmail.soft")
  },
  multipleEmail: {
    full: () => i18n.t("form-validations.multipleEmail.full"),
    soft: () => i18n.t("form-validations.multipleEmail.soft")
  },
  validDate: {
    full: () => i18n.t("form-validations.validDateEntered.full"),
    soft: () => i18n.t("form-validations.validDateEntered.soft")
  },
  futureDate: {
    full: () => i18n.t("form-validations.futureDate.full"),
    soft: () => i18n.t("form-validations.futureDate.soft")
  },
  withFutureDate: {
    full: () => i18n.t("form-validations.futureDate.full"),
    soft: () => i18n.t("form-validations.futureDate.soft")
  },
  pastDate: {
    full: () => i18n.t("form-validations.pastDate.full"),
    soft: () => i18n.t("form-validations.pastDate.soft")
  },
  withPastDate: {
    full: () => i18n.t("form-validations.pastDate.full"),
    soft: () => i18n.t("form-validations.pastDate.soft")
  },
  isAdult: {
    full: () => i18n.t("form-validations.isAdult.full"),
    soft: () => i18n.t("form-validations.isAdult.soft")
  },
  validPhoneNumber: {
    full: () => i18n.t("form-validations.validPhoneNumber.full"),
    soft: () => i18n.t("form-validations.validPhoneNumber.soft")
  },
  validPhoneNumberWithExt: {
    full: () => i18n.t("form-validations.validPhoneNumber.full"),
    soft: () => i18n.t("form-validations.validPhoneNumber.soft")
  },
  maxLength: {
    full: params => i18n.t("form-validations.maxLengthWithParams.full", params),
    soft: params => i18n.t("form-validations.maxLengthWithParams.soft", params)
  },
  minLength: {
    full: params => i18n.t("form-validations.minLengthWithParams.full", params),
    soft: params => i18n.t("form-validations.minLengthWithParams.soft", params)
  },
  maxLenderCodeLength: {
    full: params => i18n.t("form-validations.maxLenderCodeLength.full", params),
    soft: params => i18n.t("form-validations.maxLenderCodeLength.soft", params)
  },
  minLenderCodeLength: {
    full: params => i18n.t("form-validations.minLenderCodeLength.full", params),
    soft: params => i18n.t("form-validations.minLenderCodeLength.soft", params)
  },
  minValue: {
    full: params => i18n.t("form-validations.minValue.full", params),
    soft: params => i18n.t("form-validations.minValue.soft", params)
  },
  maxValue: {
    full: params => i18n.t("form-validations.maxValue.full", params),
    soft: params => i18n.t("form-validations.maxValue.soft", params)
  },
  unique: {
    full: () => i18n.t("form-validations.unique.full"),
    soft: () => i18n.t("form-validations.unique.soft")
  },
  notBrokerOrAgent: {
    full: () => i18n.t("form-validations.notBrokerOrAgent.full"),
    soft: () => i18n.t("form-validations.notBrokerOrAgent.soft")
  },
  notCurrentAccountEmail: {
    full: () => i18n.t("form-validations.notCurrentAccountEmail.full"),
    soft: () => i18n.t("form-validations.notCurrentAccountEmail.soft")
  },
  notConnectedAccountEmail: {
    full: () => i18n.t("form-validations.notConnectedAccountEmail.full"),
    soft: () => i18n.t("form-validations.notConnectedAccountEmail.soft")
  },
  sameAs: {
    full: params => i18n.t("form-validations.sameAsWithParams.full", params),
    soft: params => i18n.t("form-validations.sameAsWithParams.soft", params)
  },
  validPassword: {
    full: () => i18n.t("form-validations.validPassword.full"),
    soft: () => i18n.t("form-validations.validPassword.soft")
  },
  validSubdomain: {
    full: () => i18n.t("form-validations.validSubdomain.full"),
    soft: () => i18n.t("form-validations.validSubdomain.soft")
  },
  confirmPassword: {
    full: () => i18n.t("form-validations.confirmPassword.full"),
    soft: () => i18n.t("form-validations.confirmPassword.soft")
  },
  notSameAsCurrentPassword: {
    full: () => i18n.t("form-validations.notSameAsCurrentPassword.full"),
    soft: () => i18n.t("form-validations.notSameAsCurrentPassword.soft")
  },
  isValidColor: {
    full: () => i18n.t("form-validations.isValidColor.full"),
    soft: () => i18n.t("form-validations.isValidColor.soft")
  },
  existingEmail: {
    full: () => i18n.t("form-validations.existingEmail.full"),
    soft: () => i18n.t("form-validations.existingEmail.soft")
  },
  confirmPin: {
    full: () => i18n.t("form-validations.confirmPin.full"),
    soft: () => i18n.t("form-validations.confirmPin.soft")
  },
  numeric: {
    full: () => i18n.t("form-validations.numeric.full"),
    soft: () => i18n.t("form-validations.numeric.soft")
  },
  validExpirationDate: {
    full: () => i18n.t("form-validations.validExpirationDate.full"),
    soft: () => i18n.t("form-validations.validExpirationDate.soft")
  },
  validCanadianPostalCode: {
    full: () => i18n.t("form-validations.validCanadianPostalCode.full"),
    soft: () => i18n.t("form-validations.validCanadianPostalCode.soft")
  },
  alphaNum: {
    full: () => i18n.t("form-validations.alphaNum.full"),
    soft: () => i18n.t("form-validations.alphaNum.soft")
  },
  alpha: {
    full: () => i18n.t("form-validations.alpha.full"),
    soft: () => i18n.t("form-validations.alpha.soft")
  },
  validSignedNumber: {
    full: () => i18n.t("form-validations.validSignedNumber.full"),
    soft: () => i18n.t("form-validations.validSignedNumber.soft")
  },
  between: {
    full: params => i18n.t("form-validations.between.full", params),
    soft: params => i18n.t("form-validations.between.soft", params)
  },
  withValidDate: {
    full: () => i18n.t("form-validations.validDateEntered.full"),
    soft: () => i18n.t("form-validations.validDateEntered.soft")
  },
  minTimeAtGroup: {
    full: params => {
      switch (params.field) {
        case "time-at":
          return i18n.t("form-validations.total36MonthsResidences");
        case "time-at-job":
          return i18n.t("form-validations.total36MonthsEmployment");
        default:
          return "";
      }
    },
    soft: params => {
      switch (params.field) {
        case "time-at":
          return i18n.t("form-validations.total36MonthsResidences");
        case "time-at-job":
          return i18n.t("form-validations.total36MonthsEmployment");
        default:
          return "";
      }
    }
  },
  minTime: {
    full: params => {
      switch (params.field) {
        case "time-at":
          return i18n.t("form-validations.total36MonthsResidences");
        case "time-at-job":
          return i18n.t("form-validations.total36MonthsEmployment");
        default:
          return "";
      }
    },
    soft: params => {
      switch (params.field) {
        case "time-at":
          return i18n.t("form-validations.total36MonthsResidences");
        case "time-at-job":
          return i18n.t("form-validations.total36MonthsEmployment");
        default:
          return "";
      }
    }
  },
  withValidSin: {
    full: () => i18n.t("form-validations.validSin"),
    soft: () => i18n.t("form-validations.validSin")
  },
  commissionSplitTotal: {
    full: () => i18n.t("direct-to-lender.commissions.commissionDetails.splitsMustAddTo"),
    soft: () => i18n.t("direct-to-lender.commissions.commissionDetails.splitsMustAddTo")
  },
  validForNetRate: {
    full: () => i18n.t("form-validations.validForNetRate.full"),
    soft: () => i18n.t("form-validations.validForNetRate.soft")
  },
  downPaymentHigherThanPurchasePrice: {
    full: () => i18n.t("form-validations.downPaymentHigherThanPurchasePrice.full"),
    soft: () => i18n.t("form-validations.downPaymentHigherThanPurchasePrice.soft")
  },
  validPurchasePrice: {
    full: () => i18n.t("form-validations.validPurchasePrice"),
    soft: () => i18n.t("form-validations.validPurchasePrice")
  },
  validEstimatedValue: {
    full: () => i18n.t("form-validations.validEstimatedValue"),
    soft: () => i18n.t("form-validations.validEstimatedValue")
  },
  validYear: {
    full: () => i18n.t("form-validations.validYear"),
    soft: () => i18n.t("form-validations.validYear")
  }
};
export default {
  computed: {
    isValidWithWarnings() {
      const leafParams = this.$v.$flattenParams();
      return leafParams.every(({
        name,
        path
      }) => {
        var _validation$$params$n;
        const fullPath = path.join(".");
        const validation = get(this.$v, fullPath);
        const isSoftError = ((_validation$$params$n = validation.$params[name]) == null ? void 0 : _validation$$params$n.softError) || null;
        if (isSoftError !== null) return true;
        return validation[name];
      });
    }
  }
};